import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayoutWithoutFooter from '../components/MainLayoutWithoutFooter';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import AddCustomerModal from '../components/modals/AddCustomerModal';
import debounce from 'lodash.debounce';
import { toast } from 'react-toastify';
import { HTTP_STATUS } from '../utils/httpStatusCodes';

const Customer = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [meta, setMeta] = useState({ currentPage: 1, pageCount: 1, perPage: 20 });
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const fetchCustomers = async (page = 1, keyword = '') => {
    setLoading(true);
    try {
      let url = `${apiUrls.POS_CUSTOMERS_URL}?page=${page}`;
      if (keyword) url += `&search=${keyword}`;

      const res = await callAPI(url, 'GET');
      const data = res.data || {};
      setCustomers(data.items || []);
      setMeta(data._meta || { currentPage: 1, pageCount: 1, perPage: 20 });
    } catch {
      alert('Failed to load customers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers(meta.currentPage, search);
  }, [meta.currentPage]);

  const debouncedSearch = debounce((val) => {
    setMeta((p) => ({ ...p, currentPage: 1 }));
    fetchCustomers(1, val);
  }, 400);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    debouncedSearch(e.target.value);
  };

  const toggleSubscribed = async (id, value) => {
    setCustomers((prev) =>
      prev.map((c) =>
        c.id === id ? { ...c, subscribed: value } : c
      )
    );
  
    try {
      const res = await callAPI(
        apiUrls.POS_CUSTOMERS_UPDATE_SUBSCRIBE,
        {},
        'POST',
        { id, value }
      );
  
      if (!(res?.data?.status == 1 || res.status === HTTP_STATUS.OK)) {
        throw new Error();
      }
  
      toast.success(
        res.data?.message ||
          (value
            ? 'Customer subscribed successfully'
            : 'Customer unsubscribed successfully')
      );
    } catch {
      setCustomers((prev) =>
        prev.map((c) =>
          c.id === id ? { ...c, subscribed: !value } : c
        )
      );
  
      toast.error('Failed to update subscription');
    }
  };
  

  return (
    <MainLayoutWithoutFooter>
      <div className="pageContent customersPage pb-3">
        <div className="container">
          <div className="sbRow mb-3">
            <h2 className="lgTitle mb-0">Customer</h2>
            <button
              className="btn iconBtn btnPrimary"
              onClick={() => setIsAddModalOpen(true)}
            >
              Add a customer
            </button>
          </div>

          <input
            type="text"
            className="form-control mb-3"
            placeholder="Search"
            value={search}
            onChange={handleSearchChange}
          />

          {loading ? (
            <div>Loading...</div>
          ) : (
            <div className="cardStyle">
              <table className="table tableStyle2">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Subscribed</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {customers.length ? (
                    customers.map((c, i) => (
                      <tr
                        key={c.id}
                        onClick={() => navigate(`/customer/${c.id}`)}
                        style={{ cursor: 'pointer' }}
                      >
                        <td>{(meta.currentPage - 1) * meta.perPage + i + 1}</td>
                        <td>{c.name}</td>
                        <td>{c.email || '--'}</td>
                        <td>{c.phone_number || '--'}</td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <input
                            type="checkbox"
                            checked={!!c.subscribed}
                            onChange={(e) =>
                              toggleSubscribed(c.id, e.target.checked)
                            }
                          />
                        </td>
                        <td onClick={(e) => e.stopPropagation()}>
                          <button
                            type="button"
                            className="btn iconBtn btnPrimary"
                            onClick={() => navigate(`/customer/${c.id}`)}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No customers found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  disabled={meta.currentPage === 1}
                  onClick={() =>
                    setMeta((p) => ({ ...p, currentPage: p.currentPage - 1 }))
                  }
                >
                  Prev
                </button>
                <span>
                  Page {meta.currentPage} of {meta.pageCount}
                </span>
                <button
                  disabled={meta.currentPage === meta.pageCount}
                  onClick={() =>
                    setMeta((p) => ({ ...p, currentPage: p.currentPage + 1 }))
                  }
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <AddCustomerModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        onSuccess={() => {
          fetchCustomers(1, search);
          setIsAddModalOpen(false);
        }}
      />
    </MainLayoutWithoutFooter>
  );
};

export default Customer;
